<template>
  <div></div>
</template>

<script>
/**
 * マップ上にプロットを表示するコンポーネント
 * @parent O.MapViewGridItem
 * @props map: Object １マップ分のインスタンスデータ
 * @props isReady: Boolean マップ情報が描画されているかのフラグ
 * @props gridMapSetting Object マップID毎にマップに設定されている全体のデータ
 */
import {
  PlotMapLayer,
  PlotMapSource,
  LayersHigherClickPriorityThanPlot,
} from "@/config/Map.js";
import { createNamespacedHelpers } from "vuex";
// Store
const { mapActions: mapActionsOfLiveMap } = createNamespacedHelpers("liveMap");

export default {
  name: "O.PlotLayer",
  data() {
    return {
      initialized: false,
      storeUnsubscribe: null,
    };
  },
  props: {
    map: Object,
    isReady: { type: Boolean, default: false },
    gridMapSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    filterPlots() {
      const { gridMapSetting } = this;
      if (!gridMapSetting) return [];
      return gridMapSetting.filter_plots || [];
    },
  },
  watch: {
    isReady() {
      if (this.isReady) {
        this.isMapReady();
        let filters = ["in", "category"].concat(this.filterPlots);
        this.filterByPlotCategories(filters);
      }
      if (!this.initialized) {
        this.initialized = true;
      }
    },
    filterPlots: {
      handler(val) {
        let filters = ["in", "category"].concat(val);
        this.filterByPlotCategories(filters);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActionsOfLiveMap(["cleanUpVesselDetail", "showPlotDetail"]),
    bindLayerClick() {
      Object.values(PlotMapLayer).forEach((layer) => {
        this.map.on("click", layer.id, (e) => {
          // クリックした場所に存在するfeatureを取得
          const features = this.map.queryRenderedFeatures(e.point, {
            layers: LayersHigherClickPriorityThanPlot,
          });
          // クリックした場所に船舶関連のfeatureが含まれていたら何もしない
          if (features.length > 0) {
            return;
          }
          this.cleanUpVesselDetail();
          this.showPlotDetail(e.features[0].properties.id);
        });
      });
    },
    /** レイヤーの描画処理 */
    isMapReady() {
      if (!this.initialized) {
        this.bindLayerClick();
        this.setPointerStyle();
      }

      this.map.addLayer({
        id: PlotMapLayer.PlotTextLayer.id,
        type: "symbol",
        source: PlotMapSource.PlotPointSource.id,
        minzoom: 8,
        maxzoom: 19,
        layout: {
          "text-field": "{title}",
          "text-anchor": "top",
          "text-size": 14,
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1,
        },
      });

      this.map.addLayer({
        id: PlotMapLayer.PlotSymbolLayer.id,
        type: "symbol",
        source: PlotMapSource.PlotPointSource.id,
        minzoom: 8,
        maxzoom: 19,
        layout: {
          "icon-ignore-placement": true,
          "icon-allow-overlap": true,
          "icon-optional": true,
          "icon-anchor": "bottom",
          "icon-image": "{icon}",
        },
        paint: {},
      });

      this.map.addLayer({
        id: PlotMapLayer.PlotPolygonLayer.id,
        type: "fill",
        source: PlotMapSource.PlotPolygonSource.id,
        minzoom: 8,
        maxzoom: 19,
        paint: {
          "fill-color": {
            type: "identity",
            property: "color",
          },
          "fill-opacity": 0.7,
        },
      });

      this.map.addLayer({
        id: PlotMapLayer.PlotPolygonTextLayer.id,
        type: "symbol",
        source: PlotMapSource.PlotPolygonSource.id,
        minzoom: 8,
        maxzoom: 19,
        layout: {
          "text-field": "{title}",
          "text-anchor": "top",
          "text-size": 14,
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1,
        },
      });
    },
    /** filterを実行する */
    filterByPlotCategories(filters) {
      if (!this.map) return;
      Object.values(PlotMapLayer).forEach((layer) => {
        if (this.map.getLayer(layer.id)) {
          this.map.setFilter(layer.id, filters);
        }
      });
    },
    setPointerStyle() {
      Object.values(PlotMapLayer).forEach((layer) => {
        let self = this;
        this.map.on("mousemove", layer.id, () => {
          self.setCursor(true, self);
        });
        this.map.on("mouseleave", layer.id, () => {
          self.setCursor(false, self);
        });
      });
    },
    setCursor(isPointer, self) {
      self.map.getCanvas().style.cursor = isPointer ? "pointer" : "";
    },
  },
};
</script>

<style scoped></style>
